import { Form, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import './ModalSchedules.scss'
import { useTheme } from '../../../utils/contexts/ThemeContext';

export interface Schedule {
    field: string,
    show: boolean,
    order: number,
    active: boolean,
    startTime: string,
    endTime: string,
}

export enum SchedulesFields {
    Active = 'active',
    StartTime = 'startTime',
    EndTime = 'endTime'
}

const ModalSchedules = (props: {
    showModal: boolean,
    params: Schedule[] | undefined,
    onSave: () => void,
    onHide: () => void,
    onChangeParams: (param: string, subparam: SchedulesFields, value: any) => void,
}) => {

    const { t } = useTranslation()
    const theme = useTheme()
    return (
        <div className='schedules-modal'>
            <Modal show={props.showModal} onHide={props.onHide} backdrop='static' keyboard={false} centered size='lg'>
                <Modal.Header className='position-relative d-block' style={{ color: "var(--text-primary)" }}>
                    <p className='modal-title-custom m-0 text-start text-lg-center'>{t("Schedules")}</p>
                    <button type='button' className='btn-close position-absolute end-0 top-50 translate-middle-y me-3' aria-label='Close' onClick={props.onHide}></button>
                </Modal.Header>

                <Modal.Body className=' px-1 px-md-3'>
                    <div className='d-flex rounded-1 flex-column justify-content-center paramsContainer'>
                        <div className='row my-0 mx-1'>
                            {props.params?.map((param: Schedule) => (
                                <div key={param.field} className='col-12 px-1 modal-item'>
                                    <div className='row my-1 mx-1 d-flex justify-content-center align-items-center'>
                                        <div className='col-2 p-0 '>
                                            <span className='modal-label mb-0 text-truncate w-100'>{`${t(param.field)}`}</span>
                                        </div>
                                        <div className='col-2 p-0 d-flex flex-row justify-content-center align-items-center'>
                                            <div className='row'>
                                                <Form.Check
                                                    type='switch'
                                                    id={`${param.field}-switch`}
                                                    checked={param.active}
                                                    label={param.active ? "On" : "Off"}
                                                    onChange={(e) => props.onChangeParams(param.field, SchedulesFields.Active, e.target.checked)}
                                                />
                                            </div>
                                        </div>
                                        <div className='col-4 px-1'>
                                            <Form.Control type='time' value={param.startTime} onChange={(e) => props.onChangeParams(param.field, SchedulesFields.StartTime, e.target.value)} />
                                        </div>
                                        <div className='col-4 px-1'>
                                            <Form.Control type='time' value={param.endTime} onChange={(e) => props.onChangeParams(param.field, SchedulesFields.EndTime,e.target.value)} />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <button className='btn-Custom btn-IDGreen' onClick={props.onSave}>
                        {t('Save')}
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default ModalSchedules